import { Currency } from './Currency';
import { Lang } from './core/language';

export enum RoundOptionsTranslated {
  'true' = 'page.invoice.opt-input-round',
  'false' = 'page.invoice.opt-input-unround',
}

export enum DirectionDoc {
  INPUT_DOC = 'InputDoc',
  OUTPUT_DOC = 'OutputDoc',
  UNKNOWN = 'Unknown',
}

export enum DirectionDocTranslated {
  'InputDoc' = 'direction.input-doc',
  'OutputDoc' = 'direction.output-doc',
  'Unknown' = 'direction.unknown',
}

export enum ConnectionAttributes {
  FULLY_CONNECTED = 'FullyConnected',
  PARTIALLY_CONNECTED = 'PartiallyConnected',
}

export enum ConnectionAttributesTranslated {
  'FullyConnected' = 'connection-attributes.fully-connected',
  'PartiallyConnected' = 'connection-attributes.partially-connected',
}

export enum DocumentType {
  // Zálohový list
  DEPOSIT_SLIP = 'PrepaymentInvoice',
  // Daňový doklad na přijatou platbu
  TAX_RECEIPT_FOR_PAYMENT_RECIEVED = 'TaxReceiptForReceivedPayment',
  // Opravný daňový doklad
  TAX_DOCUMENT_CORRECTIVE = 'TaxDocumentCorrective',
  // Daňový doklad běžný
  TAX_DOCUMENT_ORDINARY = 'TaxDocumentOrdinary',
  // Daňový doklad zjednodušený
  TAX_DOCUMENT_SIMPLIFIED = 'TaxDocumentSimplified',
  // Souhrnný daňový doklad
  TAX_DOCUMENT_SUMMARY = 'TaxDocumentSummary',
  // Platební kalendář
  PAYMENT_SCHEDULE = 'PaymentSchedule',
  // Splátkový kalendář
  REPAYMENT_SCHEDULE = 'RepaymentSchedule',
  // Doklad o použití
  PROOF_OF_USE = 'ProofOfUse',
  // Platební avízo
  PAYMENT_ADVICE = 'PaymentAdvice',
  // Faktura
  INVOICE = 'Invoice',
  // Účtenka
  RECEIPT = 'Receipt',
}

export enum DocumentTypeTranslated {
  // Zálohový list
  'PrepaymentInvoice' = 'document-type.prepayment-invoice',
  // Daňový doklad na přijatou platbu
  'TaxReceiptForReceivedPayment' = 'document-type.tax-receipt-for-recieved-payment',
  // Opravný daňový doklad
  'TaxDocumentCorrective' = 'document-type.tax-document-corrective',
  // Daňový doklad běžný
  'TaxDocumentOrdinary' = 'document-type.tax-document-ordinary',
  // Daňový doklad zjednodušený
  'TaxDocumentSimplified' = 'document-type.tax-document-simplified',
  // Souhrnný daňový doklad
  'TaxDocumentSummary' = 'document-type.tax-document-summary',
  // Platební kalendář
  'PaymentSchedule' = 'document-type.payment-schedule',
  // Splátkový kalendář
  'RepaymentSchedule' = 'document-type.repayment-schedule',
  // Doklad o použití
  'ProofOfUse' = 'document-type.proof-of-use',
  // Platební avízo
  'PaymentAdvice' = 'document-type.payment-advice',
  // Faktura
  'Invoice' = 'document-type.invoice',
  // Účtenka
  'Receipt' = 'document-type.receipt',
}

export enum DocumentStatus {
  CONCEPT = 'Concept',
  ISSUED = 'Issued',
  BOOKED_LOCAL = 'BookedLocal',
  EXPORTED = 'Exported',
  CANCELED = 'Canceled',
  TO_BE_MINED = 'ToBeMined',
  TO_BE_MINED_AUTOMATICALLY = 'ToBeMinedAutomatically',
}

export enum DocumentStatusTranslated {
  'Concept' = 'document-status.concept',
  'Issued' = 'document-status.issued',
  'BookedLocal' = 'document-status.booked-local',
  'Exported' = 'document-status.exported',
  'Canceled' = 'document-status.canceled',
  'ToBeMined' = 'document-status.to-be-mined',
  'ToBeMinedAutomatically' = 'document-status.to-be-mined-automatically',
}

export enum VatRegime {
  STANDART = 'Standardní',
  TRANSFER_DUTY = 'Přenesení daňové povinnosti',
  REVERSE_CHARGE = 'Reverse charge',
  OUT_OF_CHARGE = 'Mimo daň',
}

export enum VatRegimeTranslated {
  'Standartní' = 'vat-regime.standart',
  'Přenesení daňové povinnosti' = 'vat-regime.transfer-duty',
  'Reverse-charge' = 'vat-regime.reverse-charge',
  'Mimo daň' = 'vat-regime.out-of-charge',
}
export enum VatRate {
  BASIC = 'Základní sazba',
  FIRST_REDUCED = 'První snížená sazba',
  SECOND_REDUCED = 'Druhá snížená sazba',
  TAX_FREE = 'Osvobozené plnění',
  TRANSFER_TAX_DUTY = 'Přenesení daňové povinnosti',
  OUT_OF_VAT = 'Mimo režim DPH',
  VAT_REGIME = 'Režim DPH',
  REVERSE_CHARGE = 'Reverse charge',
}

export enum VatRateTranslated {
  'Základní sazba' = 'vat-rate.basic',
  'První snížená sazba' = 'vat-rate.first-reduced',
  'Druhá snížená sazba' = 'vat-rate.second-reduced',
  'Osvobozené plnění' = 'vat-rate.tax-free',
  'Přenesení daňové povinnosti' = 'vat-rate.transfer-tax-duty',
  'Mimo režim DPH' = 'vat-rate.out-of-vat',
  'Režim DPH' = 'vat-rate.vat-regime',
  'Reverse charge' = 'vat-rate.reverse-charge',
}

export enum PaymentTypes {
  BANK_TRANSFER = 'bank-transfer',
}
export interface Payment {
  type?: PaymentTypes;
  currency?: Currency;
  bankAccountNumber?: string;
  bankCode?: string;
  variableSymbol?: string;
  specificSymbol?: string;
  swift?: string;
  iban?: string;
}
export interface DocumentsFilter {
  documentDirection?: string | null;
  documentType?: string | null;
  filterFrom?: Date | null;
  filterTo?: Date | null;
}

export interface InvoiceItem {
  id?: string;
  documentId: string;
  name: string;
  code: string;
  price: number;
  vatRatio: number;
  vatCode: string;
  vat: number;
  priceTotal: number;
  unit: string;
  quantity: number;
  currency: string;
}

export enum OptionalFieldType {
  None = 'None',
  Header = 'Header',
  SectionUnderSupplier = 'SectionUnderSupplier',
  Footer = 'Footer',
}

export enum OptionalFieldTypeTranslated {
  'None' = 'optional-field-type.none',
  'Header' = 'optional-field-type.header',
  'SectionUnderSupplier' = 'optional-field-type.section-under-supplier',
  'Footer' = 'optional-field-type.footer',
}
export interface DocumentOptionalFieldCreateRequest {
  isActive: boolean;
  value: string;
  fieldType: OptionalFieldType;
  accountingDocumentId: string;
}
export interface DocumentOptionalFieldUpdateRequest extends DocumentOptionalFieldCreateRequest {
  id: number;
}

export interface DocumentOptionalField {
  id: number;
  isActive: boolean;
  isDefault: boolean;
  value: string;
  fieldType: OptionalFieldType;
  accountingDocument: InvoiceBase;
  language: Lang;
}

export interface DocumentOptionalFieldLink {
  id: number;
  accountingDocumentId: string;
  optionalField: DocumentOptionalField;
}

export interface InvoiceBaseCreateRequest {
  companyId?: number;
  documentNumber?: string;
  documentStatus?: string;
  direction?: DirectionDoc;
  type?: DocumentType;
  variableSymbol?: string;
  bankAccountNumber?: string;
  swift?: string;
  iban?: string;
  orderNumber?: string;
  specificSymbol?: string;
  issued: Date | string;
  dateOfTaxableTransaction: Date | string;
  dueDate: Date | string;
  supplierName?: string;
  supplierAddressLine1?: string;
  supplierAddressLine2?: string;
  supplierAddressCity?: string;
  supplierAddressPostCode?: string;
  supplierAddressCountry?: string;
  supplierCompanyId?: string;
  supplierVatId?: string;
  subscriberName?: string;
  subscriberCompanyId?: string;
  subscriberVatId?: string;
  subscriberAddressLine1?: string;
  subscriberAddressLine2?: string;
  subscriberAddressCity?: string;
  subscriberAddressPostCode?: string;
  subscriberAddressCountry?: string;
  subscriberDeliveryName?: string;
  subscriberDeliveryAddressLine1?: string;
  subscriberDeliveryAddressLine2?: string;
  subscriberDeliveryAddressCity?: string;
  subscriberDeliveryAddressPostCode?: string;
  subscriberDeliveryAddressCountry?: string;
  isSubscriberDeliveryDifferent?: boolean;
  currency?: string;
  currencyRatesDate?: Date;
  paymentDate?: Date | string | string;
  conversionRate?: number;
  rounding?: number;
  total: number;
  totalWithVat?: number;
  items: InvoiceItem[];
  note?: string;
  itemHeadline?: string;
  language?: string;
  numberOfDaysDue?: number;
  accountingDocumentOnAccountingDocumentId?: number;
  optionalFields?: DocumentOptionalFieldLink[];
  connectionAttributes?: string[];
  vatCodeSummaryTextNote?: string | null;
}

export interface InvoiceBaseInputs extends InvoiceBaseCreateRequest {
  id?: string;
}
export interface InvoiceBase extends InvoiceBaseCreateRequest {
  id: string;
}
export interface InvoiceBaseUpdateRequest extends InvoiceBaseCreateRequest {
  id?: string;
}
export interface LinkedDocument {
  id: number;
  childDocument: InvoiceBase;
  parentDocument: InvoiceBase;
}
